<category-component></category-component>
<div class="feedback-main">
    <div class="feedback-surery">
        <iframe *ngIf="url !== ''" srcdoc="" id="myiframe" [src]="url"  (load)="datachange();" frameBorder="0"></iframe>
    </div>
</div>